<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <div class="railroad-grid-container">
        <dx-data-grid
            bds-grid
            id="bdsReportGrid"
            [dataSource]="gridSource"
            height="80vh"
            minHeight="200px"
        >
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxi-column
                dataField="Consignee"
                dataType="string"
                cellTemplate="consigneeTemplate"
                caption="Consignee"
                [minWidth]="200"
                allowSearch="true"
            ></dxi-column>

            <div *dxTemplate="let item of 'consigneeTemplate'">
                <p class="">{{ item.data.cust_no }} {{ item.data.cust_name }}</p>
            </div>
            <dxi-column
                dataField="Dest"
                dataType="string"
                cellTemplate="destTemplate"
                caption="Destination"
                [minWidth]="150"
                allowSearch="true"
            ></dxi-column>

            <div *dxTemplate="let item of 'destTemplate'">
                <p class="">{{ item.data.dest_city }} {{ item.data.dest_state }}</p>
            </div>
            <dxi-column
                dataField="cars_held"
                dataType="number"
                caption="#Cars Held"
                [minWidth]="120"
            ></dxi-column>
            <dxi-column
                dataField="avg_hold_days"
                dataType="number"
                caption="Avg. Hold Days"
                [minWidth]="120"
            ></dxi-column>
            <dxi-column
                dataField="std_dev_days"
                dataType="number"
                caption="Std. Dev"
                [minWidth]="120"
            >
                <dxo-format type="fixedPoint" [precision]="3"></dxo-format>
            </dxi-column>
        </dx-data-grid>
    </div>
</div>
